export default "__VITE_ASSET__B20K2e0k__"